import { MeasurementResult } from "./type";

export const getPostsSelector = (data: MeasurementResult[]) : MeasurementResult[] => {
  return data.slice(0, 10);
};

interface SelectFunc {
  (data: MeasurementResult[]): MeasurementResult[];
}

export const selectByParamCodes = (paramCodes : string[]) : SelectFunc => {
  const target = (data: MeasurementResult[]) : MeasurementResult[] => {
    return data.filter(elem => paramCodes.includes(elem.paramCode));
  };
  const handler = {
    apply(target: SelectFunc, thisArg: any, argArray: any[]) {
        thisArg;
        return target(argArray[0]);
    },
  };
  return new Proxy<SelectFunc>(target, handler);
}
